import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ---------------addCategorySchema-------------
export const addCategorySchema = Yup.object()
  .shape({
    name: Yup.string().required(Strings.validation.fieldRequired(Strings.field.name)),
    image: Yup.string().required(Strings.validation.uploadRequired(Strings.field.image)),
    type: Yup.string().required(Strings.validation.selectRequired(Strings.field.type)),
  })
  .required();

/** Child category form — parent is required (matches backend parentCategoryId). */
export const addChildCategorySchema = Yup.object()
  .shape({
    name: Yup.string().required(Strings.validation.fieldRequired(Strings.field.name)),
    image: Yup.string().required(Strings.validation.uploadRequired(Strings.field.image)),
    type: Yup.string().required(Strings.validation.selectRequired(Strings.field.type)),
    parentCategory: Yup.mixed()
      .required(Strings.validation.selectRequired(Strings.field.parentCategory))
      .test(
        'parent-selected',
        Strings.validation.selectRequired(Strings.field.parentCategory),
        (value) => {
          if (value == null || value === '') return false;
          if (typeof value === 'object' && (value as { id?: number }).id != null) return true;
          if (typeof value === 'string' && value.trim() !== '') return true;
          return false;
        }
      ),
  })
  .required();
